import React from "react";
import styled from "styled-components";

const Container = styled.input`
  border: 0;
  min-height: 38px;
  font-size: 12px;
  padding: 0px 15px;
  box-sizing: border-box;
  width: 100%;
  outline: none;
  :disabled {
    border: 1px dotted #e6e6e6;
  }
  background-color: rgba(255, 255, 255, 0);
`;

const Input = ({
  placeholder,
  required = true,
  value = "",
  onChange = () => null,
  type = "text",
  readOnly = false,
  className,
  disabled = false,
  style = {},
}) => (
  <Container
    style={style}
    className={className}
    placeholder={placeholder}
    required={required}
    value={value}
    onChange={onChange}
    type={type}
    readOnly={readOnly}
    disabled={disabled}
    autoComplete={"off"}
  />
);

export default Input;
